import React from 'react';
import { useHistory } from 'react-router-dom';
import { slugs, useRentalSteps } from '../../app/steps';
import { PageContainer } from 'shared/components/PageContainer';
import { NextLink, PrevLink, SubmitButtons } from 'shared/components/SubmitButtons';
import { PageHeading } from 'shared/components/typography';
import { App_ApplicationFragment, App_PortalFragment } from '../../generated.graphql';


interface Props {
  portal: App_PortalFragment
  application: App_ApplicationFragment;
}

export const Paid = (props: Props) => {
  // Using payment slug, since this is just a sub page of the payment step
  const steps = useRentalSteps({slug: slugs.payment})
  const history = useHistory();
  
  // Auto Redirect to next step
  // In useEffect since react complains if it redirects before it finishes the render
  React.useEffect(() => {
    if (props.application.payment !== null && steps.next) {
      history.replace(steps.next?.link);
    }
  }, [props.application.payment, steps.next?.link])
  
  return (
    <PageContainer>
      <PageHeading>Checking payment details</PageHeading>
      {props.application.validation.payment === null && (
        <>
          <div>Card details successfully stored </div>
          <SubmitButtons
            // Using steps.this, because the prev link needs to link to the this payment step, not the prev
            left={steps.this && <PrevLink to={steps.this.link}/>}
            right={steps.next && <NextLink to={steps.next.link}/>}
          />
        </>
      )}
    </PageContainer>
  )
};
